var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"select-box--container"},[_c('div',{staticClass:"select-box--top"},[_vm._t("top")],2),_vm._v(" "),_c('div',{staticClass:"select-box--content"},[_vm._t("content")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }